// angular import
import { Component, OnInit, inject, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormBuilder, FormGroup, FormsModule, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import Swal from 'sweetalert2';
// project import
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { AuthenticationService } from 'src/app/@theme/services/authentication.service';

import { environment } from 'src/environments/environment';
import { param } from 'jquery';
import { Navigation } from 'src/app/@theme/types/navigation';
import { Role } from 'src/app/@theme/types/role';

interface Roles {
  name: string;
  usuario: string;
  contrasenia: string;
  role: string;
}

@Component({
  selector: 'app-login',
  standalone: true, // Marca como standalone
  imports: [CommonModule, SharedModule, RouterModule, FormsModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss', '../authentication-1.scss', '../../authentication.scss']
})
export class LoginComponent implements OnInit {
  showOtpComponent: boolean = false;
  private formBuilder = inject(FormBuilder);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  authenticationService = inject(AuthenticationService);
  ip: string = '0.0.0.0';
  // public props
  hide = true;
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';
  errorMensaje = '';
  message: string = 'login';
  sendMessage() {}
  //menu
  menu: any[] = [];

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      usuario: ['', Validators.required],
      contrasenia: ['', Validators.required]
    });
    this.getPublicIP();
    //Login automatico -- Comentar todo el html -- http://www.blueoceanplatform.com:3040 -- enviado
    this.loginForm = this.formBuilder.group({
      usuario: ['ryanchapaxi', Validators.required],
      contrasenia: ['PlanmarketRY', Validators.required]
    });
    this.onSubmit();
    //Login automatico -- Comentar todo el html -- http://www.blueoceanplatform1.com:3041 -- endoso
    // this.loginForm = this.formBuilder.group({
    //   usuario: ['MLincango', Validators.required],
    //   contrasenia: ['Plnmrkt2025#', Validators.required]
    // });
    // this.onSubmit();
  }

  getPublicIP() {
    fetch('https://api.ipify.org?format=json')
      .then((response) => response.json())
      .then((data) => {
        this.ip = data.ip;
      })
      .catch((error) => {
        console.error('No se pudo obtener la IP', error);
      });
  }

  // convenience getter for easy access to form fields
  get formValues() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    this.authenticationService
      .login(this.formValues['usuario'].value, this.formValues['contrasenia'].value, this.ip)
      .pipe(first())
      .subscribe(
        (respuesta: any) => {
          if (respuesta.__zone_symbol__value.codigo === 0) {
            const storedUser = JSON.stringify(localStorage.getItem('currentUser'));

            //  localStorage.setItem('menu', JSON.stringify(updatedMenu));

            const parse = JSON.parse(storedUser);
            const nombre = JSON.parse(parse).nombre;
            const email = JSON.parse(parse).email;
            let secret = JSON.parse(parse).secret;
            let cuentas = JSON.parse(parse).idCuentas;
            localStorage.setItem('secret', cuentas);

            let params = {
              usuCorreo: email,
              usuNombres: nombre
            };
            this.router.navigate(['/otp']);
            localStorage.setItem('secret', secret);
            this.authenticationService.setMessage(this.message); // Envía el mensaje al servicio

            // Llenar menu
            const menuString = localStorage.getItem('menu');
            if (menuString) {
              const roleMap: Record<number, string> = {
                1: 'Admin',
                2: 'AdminEmp',
                3: 'User'
              };

              const menuParsed = JSON.parse(menuString);

              const updatedMenu = menuParsed.map((item: any) => {
                const role = roleMap[item.codigoRol] ? [roleMap[item.codigoRol]] : [];

                // Si hay hijos, también les agregamos el role
                if (item.children && Array.isArray(item.children)) {
                  item.children = item.children.map((child: any) => ({
                    ...child,
                    role
                  }));
                }

                return {
                  ...item,
                  role
                };
              });

              // Guardamos el menú ya con roles nuevamente en el localStorage
              localStorage.setItem('menu', JSON.stringify(updatedMenu));
            }

            Swal.fire({
              toast: true, // Convierte la alerta en un pequeño toast
              position: 'bottom-end', // La coloca en la esquina inferior derecha
              icon: 'success',
              title: 'El código ha sido enviado a tu correo electrónico.',
              showConfirmButton: false,
              timer: 7000, // Se cierra en 2 segundos
              timerProgressBar: true, // Barra de progreso animada
              customClass: {
                popup: 'small-toast' // Aplica una clase CSS personalizada
              }
            });
          } else {
            this.error = respuesta.__zone_symbol__value.error;
            console.log('Error', this.error);
            this.loading = false;
            Swal.fire({
              icon: 'error',
              html: 'Error al iniciar sesión, credenciales inválidas',
              buttonsStyling: false,
              confirmButtonText: '<i class="ti ti-check"></i> Entendido',
              customClass: { confirmButton: 'btn boton text-center mt-0', title: 'p-2 m-0', htmlContainer: 'fw-bold p-2' }
            });
          }
        },
        (error) => {
          this.error = error;
          this.loading = false;
          Swal.fire({
            icon: 'error',
            html: 'Error al iniciar sesión, ' + error.mensaje,
            buttonsStyling: false,
            confirmButtonText: '<i class="ti ti-check"></i> Entendido',
            customClass: { confirmButton: 'btn boton text-center mt-0', title: 'p-2 m-0', htmlContainer: 'fw-bold p-2' }
          });
        }
      );
  }

  onSubmit1() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    this.authenticationService
      .login(this.formValues['usuario'].value, this.formValues['contrasenia'].value, this.ip)
      .pipe(first())
      .subscribe(
        () => {
          this.router.navigate(['/dashboard/dashboardpayfact']);
        },
        (error) => {
          this.error = error;
          this.loading = false;
        }
      );
  }

  roles: Roles[] = [
    {
      name: 'Gabriela',
      usuario: 'admin@gmail.com',
      contrasenia: 'Admin@123',
      role: 'Admin'
    },
    {
      name: 'k',
      usuario: 'user@gmail.com',
      contrasenia: 'User@123',
      role: 'User'
    }
  ];

  // Default to the first role
  selectedRole = this.roles[0];

  onSelectRole(role: Roles) {
    this.selectedRole = role;
  }

  togglePasswordVisibility() {
    this.hide = !this.hide;
  }
}
